<template>
  <div>
    <b-table
      :dark="dark"
      hover
      outlined
      :small="small"
      :fixed="fixed"
      responsive
      :items="items"
      :fields="captions"
      :current-page="1"
      :per-page="perPage"
      @row-clicked="rowClicked"
      stickyColumn="true"
      :tbody-tr-class="rowClass"
    >
      <template slot="status" slot-scope="data">
        <b-badge :variant="getBadge(data.item.status)">
          {{ data.item.status }}
        </b-badge>
      </template>
      <template v-slot:cell(row)="data" v-if="allowRow">
        <b-form-group>
          <b-form-checkbox
            v-if="showCheckbox"
            aria-describedby="flavours"
            aria-controls="flavours"
            v-model="data.item.row"
            size="xl"
            @change="rowClicked(data.item, false)"
          />
        </b-form-group>
      </template>
      <template v-slot:cell(title.title_description)="data">
        <span v-html="data.item.title.title_description"></span>
      </template>
      <template v-slot:cell(value.caption)="data">
        <i
          class="fa fa-plus text-success"
          v-if="data.item && data.item.value && data.item.value.id == '1'"
        ></i>
        <i v-else class="fa fa-minus text-danger"></i>
      </template>
      <template v-slot:cell(value)="data">
        <i
          class="fa fa-plus text-success"
          v-if="data.item && data.item.value && data.item.value.id == '1'"
        ></i>
        <i v-else class="fa fa-minus text-danger"></i>
      </template>
      <template slot="button" slot-scope="data" v-if="!readOnly">
        <b-button
          variant="success m-1"
          @click="modify(data.item)"
          v-show="editable"
          v-b-tooltip.hover
          :title="$lang.search.edit_tooltip"
        >
          <i class="fa fa-edit"></i>
        </b-button>
        <b-button
          variant="danger m-1"
          @click="remove(data.item)"
          v-show="removable"
          v-b-tooltip.hover
          :title="$lang.search.remove_tooltip"
        >
          <i class="fas fa-times"></i>
        </b-button>
        <b-button
          variant="warning m-1"
          @click="toggle(data.item)"
          v-show="toggleable"
          v-b-tooltip.hover
          :title="$lang.search.enable_tooltip"
        >
          <i class="fa fa-lock"></i>
        </b-button>
      </template>
    </b-table>

    <paganationSearch
      class="mt-1"
      :allowPaginate="allowPaginate"
      :total="totalRows"
      :total_pages="totalPages"
      :perPage="perPage"
      v-model="page"
      @input="paging"
    />
  </div>
</template>

<script>
import paganationSearch from "@/components/base/paganationSearch";
export default {
  name: "c-table-checkbox",
  inheritAttrs: false,
  components: {
    paganationSearch,
  },
  props: {
    caption: {
      type: String,
      default: "Table",
    },
    hover: {
      type: Boolean,
      default: false,
    },
    editable: {
      type: Boolean,
      default: false,
    },
    removable: {
      type: Boolean,
      default: false,
    },
    toggleable: {
      type: Boolean,
      default: false,
    },
    striped: {
      type: Boolean,
      default: false,
    },
    bordered: {
      type: Boolean,
      default: false,
    },
    small: {
      type: Boolean,
      default: false,
    },
    fixed: {
      type: Boolean,
      default: false,
    },
    tableData: {
      type: [Array, Function],
      default: () => [],
    },
    fields: {
      type: [Array, Object],
      default: () => [],
    },

    dark: {
      type: Boolean,
      default: false,
    },
    modify: {
      type: Function,
      default: () => [],
    },
    remove: {
      type: Function,
      default: () => [],
    },
    toggle: {
      type: Function,
      default: () => [],
    },
    changePage: {
      type: Function,
      default: () => [],
    },
    totalPages: {
      type: Number,
      default: 1,
    },
    perPage: {
      type: Number,
      default: 5,
    },
    currentPage: {
      type: Number,
      default: 1,
    },
    totalRows: {
      type: Number,
      default: 1,
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
    allowPaginate: {
      type: Boolean,
      default: true,
    },
    showCheckbox: {
      type: Boolean,
      default: true,
    },
    allowRow: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      page: this.currentPage,
    };
  },
  computed: {
    items: function () {
      const items = this.tableData;
      return Array.isArray(items) ? items : items();
    },
    captions: function () {
      return this.items.length > 0 ? this.fields : [];
    },
  },
  methods: {
    rowClass(item, type) {
      if (!item) return;

      if (item.row === true) return "table-success";
    },
    getBadge(status) {
      return status === "Active"
        ? "success"
        : status === "Inactive"
        ? "secondary"
        : status === "Pending"
        ? "warning"
        : status === "Banned"
        ? "danger"
        : "primary";
    },
    getRowCount: function () {
      return this.items.length;
    },
    rowClicked(item, event) {
      if (typeof event === "number") {
        item.row = !item.row;
      }
      this.$emit("row-clicked", item);
    },
    paging(page) {
      this.changePage(page);
    },
  },
  watch: {
    currentPage(newValue, oldValue) {
      this.page = newValue;
    },
  },
};
</script>
<style>
.scrolly {
  overflow-x: scroll;
}
</style>
